export const paymentSort = (payments) => {
    const priorityTypes = [1, 2, 9]

    const priorityPayments = payments.filter((payment) =>
        priorityTypes.includes(payment.payment_type)
    )

    const otherPayments = payments.filter(
        (payment) => !priorityTypes.includes(payment.payment_type)
    )

    return [
        ...priorityPayments.sort(
            (a, b) =>
                priorityTypes.indexOf(a.payment_type) -
                priorityTypes.indexOf(b.payment_type)
        ),
        ...otherPayments,
    ]
}
